import React, { useState, useEffect, useCallback } from "react";
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import * as Yup from 'yup';
//imported
import { SYSTMENACCESS } from 'helpers/viewContent';
import { addData_, getDetail_, updateData_ } from 'store/services/commonService';
import * as Path from 'routes/paths';
import * as actions from 'store/actions/index.js';
import Select from 'react-select';

const AddEdit = ({ dispatch, match }) => {
    let editkey = match.params.id;
    const validationSchema = Yup.object().shape({
        // name: Yup.string().required('Full name is required'),
        name: Yup.string()
            .matches(/^[A-Za-z\s]+$/, 'Only text characters are allowed in the name')
            .required('Full name is required'),
        status: Yup.string().required('Status is required'),
        email: Yup.string()
            .email('Invalid email address')
            .required('Email is required'),
        password: !editkey
            ? Yup.string().min(6, 'Password must be at least 6 characters')
            : Yup.string(), // Password is not required if editKey exists
    });

    const validateData = async (data) => {
        try {
            await validationSchema.validate(data, { abortEarly: false });
            return { isValid: true, errors: {} };
        } catch (error) {
            const errors = {};
            error.inner.forEach((err) => {
                errors[err.path] = err.message;
            });
            return { isValid: false, errors };
        }
    };

    const history = useHistory();
    const [isShow, setIsShow] = useState(false);
    const [validationErrors, setValidationErrors] = useState({});
    const [editData, setEditData] = useState({});
    const [changePassword, setChangePassword] = useState(false);
    const [selectedOption, setSelectedOption] = useState([]);

    const [fields, setfields] = useState({
        name: "",
        email: "",
        password: "",
        status: "1",
    })
    const optionVal = [
        // { value: 'dashboard', label: 'Dashboard' },
        { value: 'user', label: 'Users' },
        { value: 'coach', label: 'Coach' },
        { value: 'match', label: 'Manage Tennis Match' },
        { value: 'post', label: 'Posts' },
        { value: 'category', label: 'Categories' },
        { value: 'system_access', label: 'System Access' },
        { value: 'faq', label: 'FAQ' },
        { value: 'content_page', label: 'Content Pages' },
        // { value: 'configuration', label: 'Configuration' },
    ];
    const [options, setOptions] = useState(optionVal);

    //password
    const [showPassword, setShowPassword] = useState(false);

    //password show
    const togglePasswordVisiblity = () => {
        setShowPassword(!showPassword);
    };

    const handleChange = useCallback(
        name => evt => {
            setfields(prevState => ({
                ...prevState,
                [name]: evt.target.value,
            }))
            setValidationErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
        },
        []
    )
    const changePasswordToogle = () => {
        setChangePassword(!changePassword);
    };

    async function getData() {
        try {
            let query = {
                url: 'system_access/view',
                id: editkey
            }
            dispatch(actions.persist_store({ loader: true }));
            let res = await dispatch(getDetail_(query));
            setEditData(res?.body);
            setfields(res?.body?.data)
            let finalArr = []
            let resData = res?.body?.permissionArr
            for (let val of resData) {
                finalArr.push(val.permission)
            }
            setSelectedOption(finalArr)
            dispatch(actions.persist_store({ loader: false }));
        } catch (err) {
            dispatch(actions.persist_store({ loader: false }));
            console.log(err);
        }
    }

    useEffect(() => {
        if (editkey) {
            getData()
        }
    }, []);

    //submit setting data
    const handleSubmit = async (evt) => {
        try {
            evt.preventDefault();
            const validation = await validateData(fields);
            if (validation.isValid) {
                dispatch(actions.persist_store({ loader: true }));
                setIsShow(true)
                let query = {}
                fields.permissions = selectedOption.length > 0 ? JSON.stringify(selectedOption) : []
                if (editkey) {
                    fields.password_update = changePassword
                    query = {
                        ...fields,
                        url: "system_access/edit",
                        id: editkey
                    }
                    await dispatch(updateData_(query));
                } else {
                    query = {
                        ...fields,
                        url: "system_access/add"
                    }
                    await dispatch(addData_(query));
                }
                // return
                setIsShow(false)
                dispatch(actions.persist_store({ loader: false }));
                history.push(Path.system_access)
            } else {
                setValidationErrors(validation.errors);
            }
        } catch (err) {
            setIsShow(false)
            dispatch(actions.persist_store({ loader: false }));
            console.log(err);
        }
    }
    return (
        <>
            <Helmet title={SYSTMENACCESS.CURRENT_MODULE} />
            <div className="page-header">
                <h3 className="page-title">
                    <span className="page-title-icon bg-gradient-primary text-white me-2">
                        <i className="mdi mdi-contacts menu-icon"></i>
                    </span>  {SYSTMENACCESS.CURRENT_MODULE}
                </h3>
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><Link to={Path.system_access}>System Access</Link></li>
                        <li className="breadcrumb-item active" aria-current="page">Add/Edit</li>
                    </ol>
                </nav>
            </div>
            <div className="row">
                <div className="col-12 grid-margin stretch-card">
                    <div className="card">
                        <div className="card-body">
                            <h4 className="card-title">Add/Edit</h4>
                            <form className="forms-sample" onSubmit={handleSubmit}>
                                <div className="row">
                                    <div className="form-group col-md-6">
                                        <label for="exampleInputName1">Full Name*</label>
                                        <input type="text" className="form-control" id="exampleInputName1" placeholder="Full Name*" name="name" onChange={handleChange("name")}
                                            value={fields.name}
                                        />
                                        {validationErrors.name && (
                                            <div className="text-danger err">{validationErrors.name}</div>
                                        )}
                                    </div>
                                    <div className="form-group col-md-6">
                                        <label for="exampleInputName1">E-mail*</label>
                                        <input type="text" className="form-control" id="exampleInputName1" placeholder="E-mail*" name="email" onChange={handleChange("email")}
                                            value={fields.email}
                                        />
                                        {validationErrors.email && (
                                            <div className="text-danger err">{validationErrors.email}</div>
                                        )}
                                    </div>
                                </div>
                                <div className="row">
                                    {editkey &&
                                        <div className="form-group col-md-6">
                                            <label for="exampleInputName1">You want to change password</label>
                                            <div className="col-md-12">
                                                <div className="form-check">
                                                    <label className="form-check-label">
                                                        <input type="checkbox" className="form-check-input" onClick={changePasswordToogle} /> {changePassword ? 'Yes' : 'No'} <i className="input-helper"></i></label>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    {(changePassword || !editkey) &&
                                        <div className="form-group col-md-6">
                                            <label for="exampleInputName1">Password*</label>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <div className="input-group">
                                                        <input type={showPassword ? "text" : "password"} className="form-control" placeholder="Password*" value={fields.password} onChange={handleChange("password")} />
                                                        <div className="input-group-append">
                                                            <button className="btn btn-sm btn-facebook" type="button">
                                                                <i onClick={togglePasswordVisiblity} className={showPassword ? "mdi mdi-eye" : "mdi mdi-eye-off"}></i>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                {validationErrors.password && (
                                                    <div className="text-danger err">{validationErrors.password}</div>
                                                )}
                                            </div>
                                        </div>
                                    }
                                </div>
                                <div className="row">
                                    <div className="form-group col-md-6">
                                        <label for="exampleInputName1">Permissions</label>
                                        <Select
                                            value={selectedOption}
                                            onChange={setSelectedOption}
                                            options={options}
                                            // className="form-control"
                                            isMulti={true}
                                        />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <div className="row">
                                        <label for="exampleInputPassword4">Status*</label>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label className="">
                                                    <input type="radio" className="" value={'1'} name="status" onChange={handleChange("status")} checked={fields.status === '1' ? true : false} /> Active
                                                </label>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label className="">
                                                    <input type="radio" className="" value={'0'} name="status" onChange={handleChange("status")} checked={fields.status === '0' ? true : false} /> Inactive </label>
                                            </div>
                                        </div>
                                    </div>
                                    {validationErrors.status && (
                                        <div className="text-danger err">{validationErrors.status}</div>
                                    )}
                                </div>
                                <button type="submit" disabled={isShow ? true : false} className="btn btn-gradient-primary me-2">{isShow ? 'Wait..' : 'Submit'}</button>
                                <Link to={Path.system_access}><button className="btn btn-outline-secondary btn-lg">Back</button></Link>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>

    )
}

const mapStateToPros = (state) => {
    return {
    }
};
function mapDispatchToProps(dispatch) {
    return { dispatch };
}

export default connect(
    mapStateToPros,
    mapDispatchToProps
)(AddEdit);